import React from "react";
import { Button, icons } from "@a365/dsys";
import { useIsMobile } from "@a365/core";

const {
  HandHeart,
  Laptop,
  PawPrint,
  SuitcaseRolling,
} = icons;

const BannerCard5 = ({ bannerData, scrollToAnchor }) => {
  const isMobile = useIsMobile();

  return (
    <div
      className="
    m-4 xl:ml-6 relative z-10 text-wrap 
    xl:w-[792px] xl:min-w-[792px] xl:h-[280px] 
    rounded-2xl bg-brand-comp-yellow 
    py-[38px] xl:py-[44px] 
    px-4 xl:px-6 flex items-start justify-center flex-col space-y-2 xl:space-y-1
    w-full h-auto"
    >
      <span className="text-text-default text-xl xl:text-3xl font-semibold leading-6">
        {bannerData?.slide_3?.left?.title}
      </span>
      <div className="w-full text-sm xl:text-xl text-text-default xl:grid xl:grid-cols-2 flex flex-col pt-6 gap-y-3 xl:gap-y-4">
        <div className="flex">
          <Laptop size={24} className="text-icon-darker mr-4" />
          <span className="block">
            {bannerData?.slide_3?.left?.items[0].text}
          </span>
        </div>
        <div className="flex">
          <HandHeart size={24} className="text-icon-darker mr-4" />
          <span>{bannerData?.slide_3?.left?.items[2].text}</span>
        </div>
        <div className="flex">
          <SuitcaseRolling size={24} className="text-icon-darker mr-4" />
          <span>{bannerData?.slide_3?.left?.items[1].text}</span>
        </div>
        <div className="flex">
          <PawPrint size={24} className="text-icon-darker mr-4" />
          <span>{bannerData?.slide_3?.left?.items[3].text}</span>
        </div>
      </div>
      <Button
        onClick={() => scrollToAnchor("section-feature5")}
        variant="default"
        color="primary"
        icon="arrow"
        size="small"
        fullWidth={isMobile ?? false}
        classes="w-full xl:w-auto pt-5 relative z-10"
      >
        {bannerData?.slide_3?.left?.cta}
      </Button>

      <div
        className="
      bg-[url('https://assistcdn.s3.us-west-1.amazonaws.com/assets/site/banner/shape3.svg')]
      absolute 
      bg-cover 
      bg-left-top bg-no-repeat !w-[192px] !h-[328px] right-0 top-0 z-5"
      ></div>
    </div>
  );
};

export default BannerCard5;
